import RestSet, {
  defaultOneToOneRestSet,
  defaultRestSet,
  OneToOneRestSet,
} from '@common/interfaces/api/rest-set';
import NavLocalPlanner from '@common/interfaces/configuration/nav/nav-local-planner';
import NavTasks from '@common/interfaces/configuration/nav/nav-tasks';
import CleaningCommandButton from '@common/interfaces/robot/buttons/command-buttons';
import { EnvironmentPollution } from '@common/interfaces/robot/cleaning-configurations/environment-pollution';
import ParamList from '@common/interfaces/robot/configurations/param-list';
import ExcludedDate from '@common/interfaces/robot/excluded-dates/excluded-date';

interface LocalRobotConfigurationState {
  paramList: {
    data: ParamList | null;
    rest: RestSet;
  };
  cleaningConfiguration: {
    environmentPollution: {
      data: EnvironmentPollution[] | null;
      rest: RestSet;
    };
  };
  nav: {
    localPlanner: {
      data: NavLocalPlanner | null;
      rest: OneToOneRestSet;
    };
    tasks: {
      data: NavTasks | null;
      waypointsEnabledAutomatically: boolean;
      rest: OneToOneRestSet;
    };
  };
  excludedDates: {
    data: ExcludedDate[] | null;
    rest: RestSet;
  };
  buttonConfiguration: {
    data: CleaningCommandButton[] | null;
    rest: OneToOneRestSet;
  };
}

export const getInitialLocalRobotConfigurationState = (): LocalRobotConfigurationState => {
  return {
    paramList: {
      data: null,
      rest: defaultRestSet,
    },
    cleaningConfiguration: {
      environmentPollution: {
        data: null,
        rest: defaultRestSet,
      },
    },
    nav: {
      localPlanner: {
        data: null,
        rest: defaultOneToOneRestSet,
      },
      tasks: {
        data: null,
        waypointsEnabledAutomatically: false,
        rest: defaultOneToOneRestSet,
      },
    },
    excludedDates: {
      data: null,
      rest: defaultRestSet,
    },
    buttonConfiguration: {
      data: null,
      rest: defaultOneToOneRestSet,
    },
  };
};
export type { LocalRobotConfigurationState };
